var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutGovernance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 66,
    viewBox: "0 0 62 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.2473H61.3299L30.6149 0L0 15.2473Z",
    fill: "#005267"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.149 56.8008H3.96716V60.9081H0.0200806V65.0155H61.3701V60.9081H57.403V56.8008H43.6783V58.4436H17.7118V56.8008H16.1691H16.149ZM43.6583 64.9753H17.6918V63.3324H43.6583V64.9753ZM43.6583 60.0666V61.7095H17.6918V60.0666H43.6583Z",
    fill: "#005267"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1489 22.3978V18.9316H14.6262H7.49339H5.97064V22.3978H7.49339V53.4135H5.97064V56.7996H7.49339H14.6262H16.1489V53.4135H14.6262V22.3978H16.1489Z",
    fill: "#D4F0E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3592 22.3978V18.9316H53.8365H46.7037H45.181V22.3978H46.7037V53.4135H45.181V56.7996H46.7037H53.8365H55.3592V53.4135H53.8365V22.3978H55.3592Z",
    fill: "#D4F0E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7642 22.3978V18.9316H34.2414H27.1086H25.5859V22.3978H27.1086V53.4135H25.5859V56.7996H27.1086H34.2414H35.7642V53.4135H34.2414V22.3978H35.7642Z",
    fill: "#D4F0E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.9333H5.97066H7.49341H14.6262H16.1489H25.5858H27.1086H34.2414H35.7641H45.181H46.7037H53.8365H55.3592H61.3299V16.3887H0V18.9333Z",
    fill: "#005267"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2414 56.8008H27.1086H25.5858H17.6717V58.4436H43.6583V56.8008H35.7641H34.2414Z",
    fill: "#337E84"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6382 60.0879H17.6717V61.7308H43.6382V60.0879Z",
    fill: "#337E84"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6382 63.3516H17.6717V64.9945H43.6382V63.3516Z",
    fill: "#337E84"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutGovernance);
export default __webpack_public_path__ + "static/media/about_governance.bab59d42d965ddcd3e0817ba72a9769c.svg";
export { ForwardRef as ReactComponent };